import dico from './dico'

export const language = document.location.pathname.slice(0, 4) === '/en/'
  ? 'en'
  : document.location.pathname.slice(0, 4) === '/de/'
    ? 'de'
    : 'fr'

const parser = (word) => (dico[word]
  ? dico[word][language] || `__${word}`
  : `__${word}`)

export default parser
